import { ArrowBack, OpenInNew } from '@mui/icons-material'
import { Box, Button, Stack, Typography } from '@mui/material'
import { type PlanOrganizationTaskStatus } from '../../../../../models/PlanOrganizationTask'
import { TrainingList } from './TrainingList'
import { useTrainings } from '../../../../../hooks/use-trainings'

interface Props {
  planOrganizationId: number
  planOrganizationTaskStatus: PlanOrganizationTaskStatus
  priorityId: number
  readOnly: boolean
  trackingReadonly: boolean
  onBack: () => void
  implementationPhase?: boolean
  handleViewContract?: () => void
}

export const RCNProvidedProfessionalDevelopment = (props: Props): JSX.Element => {
  const {
    isLoading,
    seriesTrainings,
    singleTrainings,
    reloadTrainings
  } = useTrainings(props.priorityId, props.implementationPhase)

  return (
    <Box data-testid='rcnProvidedProfessionalDevelopment' sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    }}
    >
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <Button
          data-testid="backPdrsButton"
          onClick={props.onBack}
          sx={{
            padding: '5px 10px',
            backgroundColor: 'var(--grey-50)',
            color: 'var(--grey-500)',
            width: 'fit-content',
            textTransform: 'none'
          }}
        >
          <ArrowBack sx={{ mr: '10px' }} />
          Professional Learning
        </Button>

        {props.implementationPhase === true && (
          <Button
            data-testid="viewContractButton"
            sx={{
              padding: '5px 10px',
              backgroundColor: 'var(--grey-50)',
              color: 'var(--grey-500)',
              width: 'fit-content',
              textTransform: 'none'
            }}
            onClick={props.handleViewContract}
          >
            View Contract
            <OpenInNew fontSize='small' sx={{ ml: '10px' }} />
          </Button>
        )}
      </Stack>

      <Typography variant='h1'>RCN Provided Professional Learning</Typography>
      <Typography variant='body1'>
        List all professional learning planned by the RCN, including training series and single training events. For each event, indicate the title, ISD/District host, format, whether it can be posted on the START website, resources needed, and budget request. Click “Things to Consider” to see examples of content and format.
      </Typography>

      <TrainingList
        isSeries={true}
        trainings={seriesTrainings}
        isLoading={isLoading}
        reloadTrainings={reloadTrainings}
        planOrganizationId={props.planOrganizationId}
        priorityId={props.priorityId}
        readOnly={props.readOnly}
        trackingReadonly={props.trackingReadonly}
        implementationPhase={props.implementationPhase}
        hideDelete={false}
      />

      <TrainingList
        isSeries={false}
        trainings={singleTrainings}
        isLoading={isLoading}
        reloadTrainings={reloadTrainings}
        planOrganizationId={props.planOrganizationId}
        priorityId={props.priorityId}
        readOnly={props.readOnly}
        trackingReadonly={props.trackingReadonly}
        implementationPhase={props.implementationPhase}
        hideDelete={false}
      />
    </Box>
  )
}
